import { h } from '@stencil/core';

/**
 * Renders a contained line chart with adjustable height and width
 */
export const ContainedChart = (props: {
  chartHeight: number;
  chartWidth: number;
  chartId: string;
  setRef: (element: HTMLElement) => void;
}) => {
  const { chartHeight, chartWidth, chartId, setRef } = props;
  const chartStyle = {
    height: `${chartHeight}px`,
    width: `${chartWidth}px`,
  };
  return (
    <fluid-grid-item auto={true}>
      <div class='chart-container' style={chartStyle}>
        <canvas id={chartId} ref={(cr) => setRef(cr)} />
      </div>
    </fluid-grid-item>
  );
};

/**
 * Renders a responsive line chart that will fill its container
 */
export const ResponsiveChart = (props: {
  chartId: string;
  setRef?: (element: HTMLElement) => void;
}) => {
  const { chartId, setRef } = props;
  return (
    <fluid-grid-item col={12}>
      <canvas id={chartId} ref={(cr) => setRef(cr)} />
    </fluid-grid-item>
  );
};

/**
 * Renders a line chart with responsive width and adjustable height
 */
export const HeightContainedChart = (props: {
  chartHeight: number;
  chartId: string;
  setRef?: (element: HTMLElement) => void;
}) => {
  const { chartHeight, chartId, setRef } = props;
  const chartStyle = {
    height: `${chartHeight}px`,
  };
  return (
    <fluid-grid-item col={12}>
      <div class='chart-container' style={chartStyle}>
        <canvas id={chartId} ref={(cr) => setRef(cr)} />
      </div>
    </fluid-grid-item>
  );
};
